export default {
  methods: {
    trackEvent(category, event, action, label) {
      if (window.dataLayer) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          category,
          event,
          action,
          label
        });
      }
    },
    trackCustomEvent(eventData) {
      if (window.dataLayer) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          ...eventData
        });
      }
    }
  }
};
